module.exports = __webpack_public_path__ + "static/x51-6b11d192525f8f6bfc8dc21a11d1d809.png";